<template>
  <div class="measure-container">
    <div class="header">
      <img src="@/assets/icon_dean_home_report_measure_1.png" alt="测量图标" class="icon" />
      <span class="title">今日测量</span>
    </div>
    <table class="data-table">
      <thead>
        <tr>
          <th>时间</th>
          <th>血氧(%)</th>
          <th>脉率(bpm)</th>
          <th>血压(mmHg)</th>
          <th>体温(°C)</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table_row" v-for="item in measureDayList || []" :key="item.time">
          <td>{{ getTimeVal(item) }}</td>
          <td :class="{ abnormal: item.oxygenSaturationAbnormal }">{{ getXyVal(item) }}</td>
          <td :class="{ abnormal: item.pulseRateAbnormal }">{{ getMlVal(item) }}</td>
          <td>
						<span :class="{ abnormal: item.systolicBloodPressureAbnormal }">{{ getSsVal(item) }}</span>
						<span :class="{ abnormal: item.systolicBloodPressureAbnormal && item.diastolicBloodPressureAbnormal }">/</span>
						<span :class="{ abnormal: item.diastolicBloodPressureAbnormal }">{{ getSzVal(item) }}</span>
					</td>
          <td :class="{ abnormal: item.bodyTemperatureAbnormal }">{{ getTwVal(item) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'MeasureComponent',
	props: {
		measureDayList: {
			type: Array,
			default: []
		},
	},
  data() {
    return {
      tableData: [
        {
          time: '08:18',
          oxygen: 98,
          pulse: 68,
          bp: '120/90',
          temp: 37,
          pulseAbnormal: false,
          bpAbnormal: false,
          tempAbnormal: false
        },
        {
          time: '13:13',
          oxygen: 96,
          pulse: 120,
          bp: '140/90',
          temp: 38,
          pulseAbnormal: true,
          bpAbnormal: true,
          tempAbnormal: true
        },
        {
          time: '19:13',
          oxygen: 98,
          pulse: 68,
          bp: '120/90',
          temp: 37,
          pulseAbnormal: false,
          bpAbnormal: false,
          tempAbnormal: false
        }
      ]
    }
  },
	mounted() {
	},
	methods: {
		getTimeVal(item) {
			return this.$lodash.get(item, "time", "-" ) !== null ? this.$lodash.get(item, "time", "-" ) : '-'
		},
		getXyVal(item) {
			return this.$lodash.get(item, "oxygenSaturation", "-" ) !== null ? this.$lodash.get(item, "oxygenSaturation", "-" ) : '-'
		},
		getMlVal(item) {
			return this.$lodash.get(item, "pulseRate", "-" ) !== null ? this.$lodash.get(item, "pulseRate", "-" ) : '-'
		},
		getSsVal(item) {
			let str = (this.$lodash.get(item, "systolicBloodPressure", "-" ) !== null ? this.$lodash.get(item, "systolicBloodPressure", "-" ) : '-');
			return str;
		},
		getSzVal(item) {
			let str = (this.$lodash.get(item, "diastolicBloodPressure", "-" ) !== null ? this.$lodash.get(item, "diastolicBloodPressure", "-" ) : '-');
			return str;
		},
		getTwVal(item) {
			return this.$lodash.get(item, "bodyTemperature", "-" ) !== null ? this.$lodash.get(item, "bodyTemperature", "-" ) : '-'
		},
	}
}
</script>

<style lang="scss" scoped>
.measure-container {
	margin-top: 20px;
	margin-bottom: 20px;
  font-family: 'Arial', sans-serif;

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .icon {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }

    .title {
      font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #262626;
			line-height: 20px;
    }
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;

		thead th {
			font-family: PingFangSC, PingFang SC;
			font-weight: 600;
			font-size: 16px;
			color: #262626;
			line-height: 22px;
		}

    th, td {
      border: 1px solid #ddd;
      padding: 10px;
      text-align: center;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #262626;
			line-height: 22px;
    }

    th {
      background-color: rgba(243, 244, 247, 1);
      font-weight: bold;
    }

    .abnormal {
      color: red;
    }

		.table_row:nth-child(even) {
			background: #F9FAFA;
		}
		.table_row:nth-child(odd) {
			background: #FFFFFF;
		}
		
  }
}
</style>